import React, { useState } from 'react';
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline';
import ModalData from '../../../../../../components/common/ModalData';
import { Link } from 'react-router-dom';
import { PlusIcon } from '@heroicons/react/20/solid';
import { useSelector } from 'react-redux';
import { AddProject } from '../modal/AddProject';
import {
  useUpdateCandidateMutation,
  useGetCandDetailsQuery,
  useDeleteProjectMutation,
} from '../../../../../../features/hiringstages/sourcingApiSlice';

import Modal from '../../../../../../components/common/Modal';
import Notification from '../../../../../../components/common/Notification';
import DateToIndiaFormat from '../../../../../../components/common/DateToIndiaFormat';

const CandProjects = ({ gotoAddSourcing, showNotificationMsg }) => {
  const initialArr =
    useSelector((state) => state.candidatedetails?.projects) || [];
  const candiid = useSelector((state) => state.candidatedetails?.id) || [];

  const [deleteProject, { isDeleteProjectLoading }] =
    useDeleteProjectMutation();

  const [updateCandidate, { isCandLoading }] = useUpdateCandidateMutation();

  const {
    data: canddetails,
    error: canddetailsErr,
    isLoading: canddetailsLoading,
    isFetching: canddetailsFetching,
    isSuccess: canddetailsSuccess,
  } = useGetCandDetailsQuery(candiid, { refetchOnMountOrArgChange: true });

  const [projects, setProjects] = useState(canddetails?.data?.projects);

  const [openModal, setOpenModal] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [deptId, setDeptId] = useState(null);

  const [openModalData, setOpenModalData] = useState(false);
  const [openModalDataValues, setOpenModalDataValues] = useState();

  const openModalDataWindow = (sendtoModal) => {
    // setManpowerId(id);
    setOpenModalDataValues(sendtoModal);
    setOpenModalData(!openModalData);
  };
  const closeModalDataWindow = () => {
    setOpenModalData(!openModalData);
  };
  const onModalDataSubmit = (e) => {
    e.preventDefault();
    showNotificationMsg();
  };

  const closeNotificationMsg = () => {
    setShowNotification(false);
  };

  const openModalWindow = (id) => {
    setDeptId(id);
    setOpenModal(!openModal);
  };
  const closeModalWindow = () => {
    setOpenModal(!openModal);
  };

  const onModalSubmit = async () => {
    try {
      const deleteAdminMytask = await deleteProject(deptId).unwrap();
      closeModalWindow();
      showNotificationMsg();
    } catch (error) {}
  };
  return (
    <>
      <div className="flex justify-between px-6 pt-2 items-center">
        <h1 className="text-2xl font-bold">Projects List</h1>
        <Link
          type="button"
          to={''}
          className="flex justify-center rounded-3xl border border-transparent bg-violet-900 py-3 px-6 text-sm font-medium text-white shadow-sm hover:bg-violet-700 focus:outline-none "
          onClick={() =>
            openModalDataWindow({
              mode: 'Add',
              title: 'Create Project',
            })
          }
        >
          <PlusIcon className="-ml-1 mr-2 h-5 w-5 text" aria-hidden="true" />
          Create Project
        </Link>
      </div>
      {canddetails?.data.projects.length > 0 ? (
        <>
          {canddetails?.data.projects.map((project) => (
            <div className="border-t border-gray-200" key={project.id}>
              <div className="flex justify-between px-6 py-5">
                <div className="">
                  <h4 className="font-semibold text-2xl text-blue-700">
                    {project.title}
                  </h4>
                  <h6 className="font-medium text-xl text-red-500 pb-2">
                    {project.client}
                  </h6>
                  <h6 className="font-medium text-md text-gray-600 pt-1 pb-3">
                    <span className="font-bold">Project Duration:</span>{' '}
                    {DateToIndiaFormat(project.worked_from)}{' '}
                    {project.worked_to
                      ? ` - ` + DateToIndiaFormat(project.worked_to)
                      : ''}
                  </h6>
                  <p className=" leading-relaxed">{project.description}</p>
                </div>
                <div className="flex items-start ">
                  <div className="flex items-center ">
                    {/* <span>Edit</span> */}
                    <PencilSquareIcon
                      className="-ml-1 mr-2 h-8 w-8 cursor-pointer"
                      aria-hidden="true"
                      onClick={() =>
                        openModalDataWindow({
                          mode: 'Edit',
                          obj: project,
                        })
                      }
                    />
                    <TrashIcon
                      className="-ml-1 mr-5 h-8 w-8 cursor-pointer text-red-600"
                      aria-hidden="true"
                      onClick={() => openModalWindow(project.id)}
                      // onClick={() => removeTechSkill(techskill.skill_id)}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      ) : (
        <div className="mx-6">No Projects Found</div>
      )}

      <ModalData
        isModalDataOpen={openModalData}
        onModalDataClose={closeModalDataWindow}
      >
        <AddProject
          onModalDataClose={() => closeModalDataWindow()}
          onModalDataSubmit={() => onModalDataSubmit()}
          setShowNotification={() => showNotificationMsg()}
          data={openModalDataValues}
        />
        {/* <AddEducation
          onModalDataClose={() => closeModalDataWindow()}
          onModalDataSubmit={() => onModalDataSubmit()}
          showNotify={() => showNotificationMsg()}
          data={openModalDataValues}
        /> */}
        {/* <AddProject
          onModalDataClose={() => closeModalDataWindow()}
          onModalDataSubmit={() => onModalDataSubmit()}
          showNotify={() => showNotificationMsg()}
          data={openModalDataValues}
        /> */}
      </ModalData>

      <Notification
        isShow={showNotification}
        onClose={() => closeNotificationMsg()}
      />

      <Modal
        isModalOpen={openModal}
        onClose={() => closeModalWindow()}
        onSubmit={() => onModalSubmit()}
      >
        modal
      </Modal>
    </>
  );
};

export default CandProjects;
